import { Practice } from 'EntityTypes';
import { PracticesEntitiesState, RootState } from 'StoreTypes';

export const getPractice = (state: RootState, practiceId: number): Practice =>
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'Practice | undefined' is not assignable to t... Remove this comment to see the full error message
  state.entities.practices?.byId?.[practiceId];

export const getPracticesById = (state: RootState): PracticesEntitiesState['byId'] =>
  state.entities.practices?.byId;
